import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CtaProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'text';
  showArrow?: boolean;
  fullWidth?: boolean;
}
export function Cta({
  children,
  variant = 'primary',
  showArrow = false,
  fullWidth = false,
  className = '',
  ...props
}: CtaProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-all rounded-xl';
  const variants = {
    primary: 'bg-sand hover:bg-sand-dark text-navy px-8 py-4 text-lg shadow-md hover:shadow-lg hover:-translate-y-0.5',
    secondary: 'bg-white border-2 border-navy text-navy hover:bg-paper-dark px-8 py-4 text-lg',
    text: 'bg-transparent text-navy hover:text-seaglass p-0 text-lg underline underline-offset-4 decoration-seaglass/40 hover:decoration-seaglass'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-65">
      {children}
      {showArrow && <ArrowRight className="ml-2.5 h-5 w-5" data-id="element-66" />}
    </button>;
}